import { SelectItem } from "primereact/selectitem";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";
import { product_category } from "../../models/Product/product_category";
import { ImageWithURL } from "../../types/generic.types";
import { imageProps } from "../Product/ImageSelectionTemplate/ImageCard";
export interface contextProductInterface {
  productType: SelectItem;
  setProductType: Dispatch<SetStateAction<SelectItem>>;
  productName: string;
  setProductName: Dispatch<SetStateAction<string>>;
  productDescription: string;
  setProductDescription: Dispatch<SetStateAction<string>>;
  productLink: string;
  setProductLink: Dispatch<SetStateAction<string>>;
  productCategory: product_category;
  setProductCategory: Dispatch<SetStateAction<product_category>>;
  images: ImageWithURL[];
  setImages: Dispatch<SetStateAction<ImageWithURL[]>>;
}

const ProductContext = createContext<any>({});

const ProductProvider = ({ children }: { children: JSX.Element }) => {
  const [productType, setProductType] = useState<SelectItem>({
    label: "",
    value: "",
  });
  const [productName, setProductName] = useState<string>("");
  const [productDescription, setProductDescription] = useState<string>("");
  const [productLink, setProductLink] = useState<string>("");
  const [productCategory, setProductCategory] = useState<product_category>({
    _id: "",
    name: "",
  });
  const [images, setImages] = useState<imageProps[]>([]);

  return (
    <ProductContext.Provider
      value={{
        productCategory,
        setProductCategory,
        productName,
        setProductName,
        productDescription,
        setProductDescription,
        productLink,
        setProductLink,
        productType,
        setProductType,
        images,
        setImages,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;
export const UseProductContext = () =>
  useContext(ProductContext) as contextProductInterface;
